//Display cards from the Database that belong to a customer. 

import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { FiTrash2, FiCreditCard } from 'react-icons/fi';
import { toast } from 'react-toastify'; // Add this import
import SetupForm from '../../components/stripe/SetupForm';

const CardsList = () => {
  const { token } = useSelector((state) => state.auth.user);
  const [cards, setCards] = useState([]);
  const [defaultPaymentMethod, setDefaultPaymentMethod] = useState({});

  useEffect(() => {
    //get default payment method from stripe asynchronously
    const getDefaultPaymentMethod = async () => {
      try {
        const getDefaultPM = await axios.get('/api/pay/getDefeaultPaymentMethod', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
    
       
        setDefaultPaymentMethod(getDefaultPM.data);
      } catch (error) {
        console.error('Error getting default payment method:', error);
        // You can also set some state here to indicate that an error occurred
      }
    };

    const getAllCardsBelongingToCustomer = async () => {
      try {
        const response = await axios.get('/api/pay/customerCards', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        
       
        if (Array.isArray(response.data)) {
          setCards(response.data);
          
        }
      } catch (error) {
        console.log(error);
      }
    };


    
    
    
    
    //when component mounts, get the default payment method
     getDefaultPaymentMethod();
    //get all the cards belonging to the customer
     getAllCardsBelongingToCustomer()

  }, [token]);

  //detach the card from customer and delete from db.
 const handleRemoveCard = async (pmID) => {
    if (cards.length === 1) {
      toast.warning("Please add a new card before removing the existing one.");
      return;
    }

    try {
      const { data } = await axios.post('/api/pay/detachPaymentMethod', { paymentMethodID: pmID }, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const detachedId = data.detachedPaymentMethodID;

      // Remove immediately (functional update prevents stale closure issues)
      setCards(prev => prev.filter(card => card.paymentMethodID !== detachedId));

      toast.success("Card removed.");
      // If the removed card was the default, you may want to refetch or pick another:
      if (detachedId === defaultPaymentMethod) {
        setDefaultPaymentMethod(null);
        // Optionally trigger a refetch of default + list here.
      }
    } catch (error) {
      console.error('Error removing card:', error);
      toast.error("Failed to remove the card. Please try again.");
    }
  };

  //set the card clicked on as the default card.
  const handleSetDefault = async (cardId) => {
    try {
      //send the user token and the payment method id to the backend to set the default payment method.
      const res = await axios.put('/api/pay/setDefaultPm', { cardId }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // Update the defaultPaymentMethod state with the updated default card
      setDefaultPaymentMethod(res.data);
    } catch (error) {
      //use alert to display error message
      console.log(error);
    }
  };

  return (
    <>
      <div className='mb-4 flex items-center justify-between'>
        <div>
          <h2 className="text-xl font-semibold tracking-tight text-stone-900">Payment Methods</h2>
          <p className="text-sm text-stone-500">Manage cards used for your subscription billing.</p>
        </div>
        <div className="hidden rounded-md border border-stone-200 bg-stone-50 p-2 text-stone-500 sm:block">
          <FiCreditCard className="h-4 w-4" />
        </div>
      </div>
       
      <div className="overflow-x-auto rounded-lg border border-stone-200">
        <table className="w-full min-w-max">
          <thead className="bg-stone-100 text-stone-700">
            <tr className="font-sans">
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Name on Card</th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Type</th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Last 4</th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Exp Date</th>
              <th className="px-4 py-3 text-left text-xs font-medium uppercase tracking-wider">Actions</th>
            </tr>
          </thead>
          <tbody className="bg-white text-left text-stone-700">
            {cards?.map((card) => (
              <tr key={card.paymentMethodID} className="border-t border-stone-100 hover:bg-stone-50/70">
                <td className="whitespace-nowrap px-4 py-3 text-sm">{card?.name ?? 'Unknown'}</td>
                <td className="whitespace-nowrap px-4 py-3 text-sm capitalize">{card.brand}</td>
                <td className="whitespace-nowrap px-4 py-3 text-sm">{card?.last4 ?? 'Unknown'}</td>
                <td className="whitespace-nowrap px-4 py-3 text-sm">
                  {card?.exp_Month && card?.exp_Year ? `${card.exp_Month}/${card.exp_Year}` : 'Unknown'}
                </td>
                <td className="whitespace-nowrap px-4 py-3">
                  <div className="flex items-center gap-2">
                  <button
                    type="button"
                    onClick={() => handleRemoveCard(card.paymentMethodID)}
                    className="rounded-md p-2 text-red-600 transition hover:bg-red-50 hover:text-red-700 disabled:cursor-not-allowed disabled:opacity-40"
                    disabled={card.paymentMethodID === defaultPaymentMethod}
                    aria-label="Remove card"
                  >
                    {card.paymentMethodID !== defaultPaymentMethod && <FiTrash2 className="h-4 w-4" />}
                  </button>
                  <button
                    type="button"
                    onClick={() => handleSetDefault(card.paymentMethodID)}
                    className={`rounded-md px-3 py-1.5 text-xs font-semibold transition ${
                      card.paymentMethodID === defaultPaymentMethod
                        ? "bg-orangem/20 text-orangem"
                        : "bg-robin text-ivory hover:bg-green-500"
                    }`}
                    disabled={card.paymentMethodID === defaultPaymentMethod}
                  >
                    {card.paymentMethodID === defaultPaymentMethod ? "Default Card" : "Set as Default"}
                  </button>
                  </div>
                </td>
              </tr>
            ))}
            {cards?.length === 0 && (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-sm text-stone-500">
                  No saved cards yet.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <div className='mt-4'>
        <SetupForm />
      </div>
    </>
  );
};

export default CardsList;
